import { ApiError } from '../../../lib/api';

type SafeParseIssue = {
  path: Array<string | number>;
  message: string;
  code: string;
};

type SchemaLike<T> = {
  safeParse: (payload: unknown) => {
    success: boolean;
    data?: T;
    error?: { issues: SafeParseIssue[] };
  };
};

export const validateWithSchema = <T>(
  schema: SchemaLike<T>,
  payload: unknown,
  endpoint: string
): T => {
  const parsed = schema.safeParse(payload);
  if (parsed.success && parsed.data !== undefined) {
    return parsed.data;
  }

  const details = (parsed.error?.issues ?? []).map(issue => ({
    path: issue.path.join('.'),
    message: issue.message,
    code: issue.code
  }));

  throw new ApiError(`Invalid API contract at ${endpoint}`, 500, {
    message: `Invalid API contract at ${endpoint}`,
    code: 'INVALID_API_CONTRACT',
    details
  });
};
